import { createAction, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../../../../../init-store';

type FullscreenState = {
    isFullscreen: boolean;
};
const initialState: FullscreenState = {
    isFullscreen: false,
};

const fullscreenSlice = createSlice({
    name: 'fullscreen',
    initialState: initialState,
    reducers: {
        setStoreIsFullscreen(state, action: PayloadAction<boolean>) {
            state.isFullscreen = action.payload;
        },
        resetFullscreen() {
            return initialState;
        },
    },
});

export const setIsFullscreenAction = createAction<boolean>('conference/fullscreen/isFullscreen');
export const { setStoreIsFullscreen, resetFullscreen } = fullscreenSlice.actions;
export const selectIsFullscreen = (state: RootState) => state.call.fullscreen.isFullscreen;
export const fullscreenReducer = fullscreenSlice.reducer;
